import PropTypes from 'prop-types';
import {Link} from 'react-router';
import classNames from 'classnames';
import {
  Drawer,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Tooltip,
} from '@material-ui/core';
import {ChevronLeft as ChevronLeftIcon} from '@material-ui/icons';
import {useWindowResize} from '@ozgene/gp5.hooks.use-window-resize';

export default function AppDrawer(props) {
  const {classes, drawerOpen, navTransitions, onCloseDrawer} = props;
  const {height} = useWindowResize();

  return (
    <Drawer
      variant="permanent"
      classes={{
        paper: classNames(
          classes.drawerPaper,
          !drawerOpen && classes.drawerPaperClose,
        ),
      }}
      className="printDisplayNone"
      style={{height: height}}
      open={drawerOpen}
    >
      <div className={classes.toolbar}>
        <div className={classes.title}>
          <Typography variant="h6" color="inherit">
            {process.env.REACT_APP_APP_NAME}
          </Typography>
          <Typography variant="caption">
            {process.env.REACT_APP_VERSION}
          </Typography>
        </div>
        <Tooltip title="Collapse Menu">
          <IconButton onClick={onCloseDrawer}>
            <ChevronLeftIcon />
          </IconButton>
        </Tooltip>
      </div>
      <Divider />
      <List component="nav">
        {navTransitions.map((transition, index) => (
          <Tooltip key={index} title={transition.name}>
            <ListItem
              component={Link}
              to={transition.path}
              onClick={onCloseDrawer}
              button
              dense
              divider
              className={classes.drawerListItem}
            >
              <ListItemIcon>{transition.icon}</ListItemIcon>
              <ListItemText primary={transition.name} />
            </ListItem>
          </Tooltip>
        ))}
      </List>
    </Drawer>
  );
}

AppDrawer.propTypes = {
  classes: PropTypes.object.isRequired,
  drawerOpen: PropTypes.bool.isRequired,
  navTransitions: PropTypes.array.isRequired,
  onCloseDrawer: PropTypes.func.isRequired,
};
